"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAddReservationLayout = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./admin-add-reservation-layout.scss");
const AdminAddReservationLayout = (props) => {
    const { className, children } = props;
    const classNames = (0, classnames_1.default)('admin-add-reservation-layout', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames }, children));
};
exports.AdminAddReservationLayout = AdminAddReservationLayout;
//# sourceMappingURL=AdminAddReservationLayout.js.map